import { useState } from 'react';

interface CourseBuilderLabelModalProps {
  open: boolean;
  saving?: boolean;
  onClose: () => void;
  onSubmit: (text: string) => void;
}

export function CourseBuilderLabelModal({ open, saving, onClose, onSubmit }: CourseBuilderLabelModalProps) {
  const [text, setText] = useState('');

  if (!open) return null;

  return (
    <div
      className="lms-builder-settings-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="builder-label-modal-title"
    >
      <div className="lms-builder-settings-modal__panel" style={{ maxWidth: '28rem' }}>
        <div className="lms-builder-settings-modal__head">
          <h3 id="builder-label-modal-title" className="lms-builder-settings-modal__title">
            Añadir etiqueta
          </h3>
          <button
            type="button"
            className="lms-builder-settings-modal__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>
        <form
          id="builder-label-form"
          className="lms-builder-settings-modal__body"
          onSubmit={(event) => {
            event.preventDefault();
            onSubmit(text);
          }}
        >
          <div className="form-field">
            <label className="form-label" htmlFor="builder-label-text">
              Texto de la etiqueta
            </label>
            <input
              id="builder-label-text"
              type="text"
              value={text}
              onChange={(event) => setText(event.target.value)}
              placeholder="Ej. MATERIAL DE APOYO"
              className="form-input-base uppercase"
              autoFocus
            />
            <p className="form-hint">Se mostrará como encabezado entre las actividades de la sección.</p>
          </div>
        </form>
        <div className="lms-builder-settings-modal__footer">
          <button type="button" className="lms-builder-settings-modal__btn-ghost" onClick={onClose}>
            Cancelar
          </button>
          <button
            type="submit"
            form="builder-label-form"
            disabled={saving || !text.trim()}
            className="lms-builder-settings-modal__btn-primary"
          >
            {saving ? 'Añadiendo…' : 'Añadir'}
          </button>
        </div>
      </div>
    </div>
  );
}
